import styled from 'styled-components';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const CardWrapper = styled.div`
    width: 100%;
    flex-direction: column;
    background: ${COLORS.white};
    padding: 24px;
    border-radius: 16px;
`;

export const CardTitle = styled.div<{ isPromoted: boolean, withDesc: boolean }>`
    position: relative;
    width: 100%;
    color: ${COLORS.black};
    font-size: 20px;
    line-height: 1.4;
    padding-left: ${p => p.isPromoted ? '28px' : '0'};
    margin-bottom: ${p => p.withDesc ? '4px' : '24px'};
`;

export const CardPromoIcon = styled.div`
    position: absolute;
    top: 7px;
    left: 5px;
    width: 17px;
    height: 14px;
    background: url('${require('~/static/images/menu/promo.svg')}') center / cover no-repeat;
`;

export const CardDescription = styled.div`
    width: 100%;
    font-size: 12px;
    line-height: 1.33;
    color: ${COLORS.darkGrey};
    margin-bottom: 12px;
`;

export const CardButton = styled(StyledButton)`
    padding: 8px 10px;
    min-width: auto;
    width: max-content;
    font-size: 12px;
    line-height: 1.67;
    color: ${COLORS.black};
    background: ${COLORS.yellow};
    border: none;
    margin-bottom: 24px;
`;

export const CardChildItem = styled.div`
    width: 100%;

    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const CardChildLink = styled.a`
    display: block;
    width: 100%;
    color: ${COLORS.black};
    font-size: 14px;
    line-height: 1.14;
    transition: color 0.3s ease;
    white-space: pre-wrap;
`;
